import { lazy } from 'react';

export const MedOrgInfoTab = lazy(() => import('./MedOrgInfoTab'));
